<template>
    <div class="notifications__wrapper">
        <div class="notifications__icon information__icon dropdown ">
            <span class="notifications-dropdown-toggle"
                  id="info-notification-center"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bell">
                    <i v-if="headerInfoNotifications.total > 0" class="notifications__counter">{{ headerInfoNotifications.total }}</i>
                  </i>
            </span>

            <div class="dropdown-menu notifications-dropdown notification-toggle" role="menu">
                <div class="notification-panel">
                    <div v-if="headerInfoNotifications.total > 0">
                        <div v-for="(date, index) in filteredByDateNotifications(headerInfoNotifications.data)" :key="index + date.created_at" class="date__item">
                            <div class="date__item__day">{{ date.created_at | fullDate }}</div>
                            <div>
                                <div v-for="(notification, index) in generatedArrayFromDate(headerInfoNotifications.data, date)" :key="index">
                                    <div class="notification__item">
                                        <a v-if="notification.data.has_link" class="notification__item__link" :href="notificationLink(notification)">
                                            <span class="notification__message">
                                            <div>{{ notification.message }}</div>
                                            <div class="notification__category">{{ notification.decoded_type }}</div>
                                            </span>
                                            <span class="notification__time">{{ notification.created_at | hour }}</span>
                                        </a>
                                        <span v-else class="notification__item__link">
                                            <span class="notification__message">
                                            <div>{{ notification.message }}</div>
                                            <div class="notification__category">{{ notification.decoded_type }}</div>
                                            </span>
                                            <span class="notification__time">{{ notification.created_at | hour }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="empty__notifications__container" v-else>
                        Aucune nouvelle notification
                    </div>

                    <div class="notification__item notification__item--last all__notifications">
                        <a class="notification__item__link notification__item__link--last" href="">
                            <router-link tag="span" :to="{ name: 'notifications', query: {type: 'information'}}">Voir toutes les notifications</router-link>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="notifications__icon action__icon dropdown">
            <span class="notifications-dropdown-toggle"
                  id="notification-center"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-list">
                    <i v-if="headerActionNotifications.total > 0" class="notifications__counter">{{ headerActionNotifications.total }}</i>
                  </i>
            </span>

            <div class="dropdown-menu notifications-dropdown notification-toggle" role="menu">
                <div class="notification-panel">
                    <div v-if="headerActionNotifications.total > 0">
                        <div v-for="(date, index) in filteredByDateNotifications(headerActionNotifications.data)" :key="index + date.created_at" class="date__item">
                            <div class="date__item__day">{{ date.created_at | fullDate }}</div>
                            <div>
                                <div v-for="(notification, index) in generatedArrayFromDate(headerActionNotifications.data, date)" :key="index">
                                    <div class="notification__item">
                                        <a v-if="notification.data.has_link" class="notification__item__link" :href="notificationLink(notification)">
                                            <span class="notification__message">
                                            <div>{{ notification.message }}</div>
                                            <div class="notification__category">{{ notification.decoded_type }}</div>
                                            </span>
                                            <span class="notification__time">{{ notification.created_at | hour }}</span>
                                        </a>
                                        <span v-else class="notification__item__link">
                                            <span class="notification__message">
                                            <div>{{ notification.message }}</div>
                                            <div class="notification__category">{{ notification.decoded_type }}</div>
                                            </span>
                                            <span class="notification__time">{{ notification.created_at | hour }}</span>
                                        </span>

                                        <div :id="'header-checkbox-' + notification.id"
                                            class="checkbox check-primary checkbox-circle"
                                            title="marquer comme traitée"
                                            v-if="!updatingNotificationId"
                                        >
                                            <input @click="manageToggleReadAttribute(notification)" type="checkbox" value="1" :id="notification.id">
                                            <label :for="notification.id"></label>
                                        </div>
                                        <div :id="'header-loader-' + notification.id"
                                            class="header-notification__loader"
                                            v-else-if="updatingNotificationId == notification.id"
                                        >
                                            <div class="spinner--round"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="empty__notifications__container" v-else>
                        Aucune nouvelle notification
                    </div>

                    <div class="notification__item notification__item--last all__notifications">
                        <a class="notification__item__link notification__item__link--last" href="">
                            <router-link tag="span" :to="{ name: 'notifications', query: {type: 'action'}}">Voir toutes les notifications</router-link>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.notifications__wrapper {
  display: flex;
}
.notifications__icon {
  padding: 0 10px;
}
.notification__category {
  display: inline-block;
  background: #eb7593;
  margin: 5px 0;
  padding: 3px 10px;
  color: #fff;
  font-size: 12px;
}
.notifications-dropdown-toggle {
  font-size: 20px;
  position: relative;
  .notifications__counter {
    position: absolute;
    right: -50%;
    top: -10%;
    background: linear-gradient(to right, #fb557c, #fe7265);
    color: #fff;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    font: 12px Titillium;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.notifications-dropdown {
    left: -305px !important;
    top: 30px;
    padding: 0;
    li {
        &:first-child {
            padding-top: 0;
        }
        &:last-child {
            margin: 0;
            padding: 0 15px;
        }
        a {
            padding: 0;
        }
    }
}
#notification-center {
    user-select: none;
    cursor: pointer;
}
.notification-panel {
    padding-top: 20px;
    padding-bottom: 50px;
    max-height: 80vh;
    overflow: auto;
}
.date__item__day {
    border-bottom: 1px solid #fb557a;
    color: #fb557a;
    margin: 0 10px;
    padding-left: 10px;
    padding-bottom: 10px;
}
.notification__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px;
    min-height: 50px;
    &:hover {
        background: #fafafa;
    }
    .checkbox {
        margin: 0;
        padding: 0 0 0 10px;
        label {
            min-height: 19px;
            top: 3px;
            margin-right: 0;
            padding-left: 17px !important;
        }
    }
}
.notification__item--last {
    &:hover {
        background: #eb7593;
        a {
            color: #fff;
        }
    }
}
.notification__item__link {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.notification__item__link--last {
    color: #fb557a;
    opacity: 1;
    align-items: center;
    justify-content: center;
    height: 100%;
    &:hover {
        color: #fff;
    }
}
.notification__time {
    margin: 0 0 0 10px;
    font-size: 12px;
    color: #aaa;
}
.notification__readed {
    margin: 0 0 0 10px;
}
.empty__notifications__container {
    text-align: center;
    font-size: 14px;
    margin-bottom: 20px;
}
.all__notifications {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    border-top: 1px solid #f0f0f0;
    background-color: #ffffff;
}
.header-notification__loader {
    width: 18px;
    height: 16px;
    margin-right: 0;
    margin-left: 10px;
}
.spinner--round {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    border-color: #ccc;
    border-top-color: #fb557a;
    border-left-color: #fb557a;
    animation: basic 1s infinite linear;
}
@keyframes basic {
    0%   { transform: rotate(0); }
    100% { transform: rotate(359.9deg); }
}
</style>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'headerNotifications',

    data () {
        return {
            updatingNotificationId: null
        }
    },

    async beforeMount () {
        await this.getLoggedUser().then(() => {
            this.fetchHeaderInfoNotifications()
            this.fetchHeaderActionNotifications()
        })
    },

    mounted () {
        // Gestion du click pour l'ouverture et fermeture du centre de notifications
        this.clickBinding()
    },

    methods: {
        ...mapActions(['getLoggedUser']),
        ...mapActions('notifications', [
            'fetchHeaderInfoNotifications',
            'fetchHeaderActionNotifications',
            'toggleReadAttribute',
            'fetchViewNotifications'
        ]),

        clickBinding () {
          // TODO: GERER LES OUVERTURES/FERMETURES DES 2 CENTRES DE NOTIFICATIONS
            $("body").off('click.notification')
            $("body").off('click.info-notification')
            $("body").on('click.notification', function(e) {
                let target = $(e.target)
                if (target.is('#notification-center')) {
                    $('.action__icon').toggleClass('open')
                }
                else if (target.closest(".action__icon").length) {
                    $('.action__icon').addClass('open')
                }
                else {
                    $('.action__icon').removeClass('open')
                }
            })
            $("body").on('click.info-notification', function(e) {
                let target = $(e.target)
                if (target.is('#info-notification-center')) {
                    $('.information__icon').toggleClass('open')
                }
                else if (target.closest(".information__icon").length) {
                    $('.information__icon').addClass('open')
                }
                else {
                    $('.information__icon').removeClass('open')
                }
            })
        },
        manageToggleReadAttribute(notification) {
            this.updatingNotificationId = notification.id

            this.toggleReadAttribute(notification).then(response => {
                if ('action' == notification.type_group) {
                    this.fetchHeaderActionNotifications().then(() => this.updatingNotificationId = null)
                } else if ('information' == notification.type_group) {
                    this.fetchHeaderInfoNotifications().then(() => this.updatingNotificationId = null)
                }

                if ('notifications' == this.$store.state.route.name) {
                    this.fetchViewNotifications()
                }
            })
        },
        filteredByDateNotifications (notifications) {
            let dateArray = _.uniqBy(notifications, (notification) => {
                let date = moment(notification.created_at).format('dddd DD MMMM YYYY')
                return date
            })
            return dateArray
        },
        generatedArrayFromDate (notifications, day) {
            return _.filter(notifications, (notification) => {
                return moment(day.created_at).format('DD/MM/YYYY') == moment(notification.created_at).format('DD/MM/YYYY')
            })
        },
        notificationLink (notification) {
            return window.location.origin + '/' + notification.link
        }
    },

    computed: {
        ...mapGetters('notifications', [
            'headerInfoNotifications',
            'headerActionNotifications'
        ])
    },

    filters: {
        fullDate (date) {
            return moment(date).format('dddd DD MMMM YYYY')
        },
        hour (date) {
            return moment(date).format('HH:mm')
        }
    },

    beforeDestroy () {
        $("body").off('click.notification')
        $("body").off('click.info-notification')
    },

    watch: {
        '$route' (to, from) {
            $('.notifications__icon').removeClass('open')
            $('.info-notifications__icon').removeClass('open')
        }
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Header/Notifications.vue